import { asyncApi } from '@/services/apiService'

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/master/operatingCities`;

const operatingCityService = {
  getAllAsync: async (country, isActive, onBeginCallback, onFinallyCallback) => {
    if (country || isActive === true || isActive === false) {
      let query = [];

      if (country) {
        if (Array.isArray(country)) {
          country.forEach((item) => {
            query.push(`country=${item}`);
          });
        }
        if (typeof country === "string" || country instanceof String) {
          query.push(`country=${country}`);
        }
      }

      if (isActive === true || isActive === false) {
        query.push(`active=${isActive}`);
      }

      return asyncApi.get(`${_baseEndpoint}?${query.join('&')}`, onBeginCallback, onFinallyCallback);
    }

    return asyncApi.get(`${_baseEndpoint}`, onBeginCallback, onFinallyCallback);
  }
}

export {
  operatingCityService
}



// WEBPACK FOOTER //
// ./src/services/master/operatingCityService.js